import Vue from "vue";
import * as formatters from "@/utils/formatters";

const FormatterPlugin = {
  install(VueInstance) {
    // 將所有 formatters 註冊為 Vue 實例方法 (this.$methodName)
    // 和全域過濾器 (value | filterName)
    for (const key in formatters) {
      if (Object.prototype.hasOwnProperty.call(formatters, key)) {
        // 註冊為實例方法，例如 this.$getGenderText
        // 為了避免方法名重複，使用 $ 作為前綴
        VueInstance.prototype[`$${key}`] = formatters[key];
        // 註冊為過濾器，例如 {{ 1 | getGenderText }}
        VueInstance.filter(key, formatters[key]);
      }
    }
  },
};

export default FormatterPlugin;

